/**
 * SaveToTabMenu — Dropdown menu shown when user clicks "Save to Tab"
 * in the AnswerToolbar. Lists all available tabs for the current company.
 */
import React from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { PushPin, NoteAdd, CheckCircle } from '@mui/icons-material';

export default function SaveToTabMenu({ anchorEl, open, onClose, tabs = [], onSelectTab }) {
    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    backgroundColor: 'var(--bg-2)',
                    border: '1px solid var(--border)',
                    boxShadow: 'var(--shadow)',
                    minWidth: 220,
                    maxWidth: 300,
                    '& .MuiMenuItem-root': {
                        fontSize: '0.82rem',
                        color: 'var(--text-2)',
                        py: 0.8,
                        '&:hover': {
                            backgroundColor: 'var(--bg-3)',
                            color: 'var(--text-1)',
                        },
                    },
                },
            }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        >
            <Typography
                sx={{
                    px: 2, py: 0.75, fontSize: '0.7rem', fontWeight: 600,
                    color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: 0.5,
                }}
            >
                Save AI response to tab…
            </Typography>
            {tabs.map((tab) => (
                <MenuItem
                    key={tab.tabId}
                    onClick={() => { onSelectTab(tab.tabId); onClose(); }}
                >
                    <ListItemIcon sx={{ minWidth: 28 }}>
                        {tab.isPinned ? (
                            <PushPin sx={{ fontSize: 14, color: 'var(--muted)' }} />
                        ) : (
                            <NoteAdd sx={{ fontSize: 14, color: 'var(--muted)' }} />
                        )}
                    </ListItemIcon>
                    <ListItemText
                        primary={tab.tabName}
                        primaryTypographyProps={{ fontSize: '0.82rem' }}
                    />
                    {tab.content?.plainText?.trim() && (
                        <CheckCircle sx={{ fontSize: 12, color: 'var(--brand)', ml: 1, opacity: 0.6 }} />
                    )}
                </MenuItem>
            ))}
        </Menu>
    );
}
